<template>
  <section>
      <el-card class="box-card" style="margin-top:16px;" >
                 <div slot="header" class="clearfix">
                     <img src="@/imgs/hafa.png" alt="">
                    <span style="margin-left:8px;">{{ $t('全部评论') }}（{{commentList.length}}）</span>
                    <!-- <el-button style="float: right; padding: 3px 0" type="text">操作按钮</el-button> -->
                </div>
                <div  class="text item" style="margin-bottom: 69px;" v-if="commentList.length!=0">
                    <div class="cl-card">
                        <div class="bssCenten" v-for="(item,index) in commentList" :key="index">
                            <div class="clearfix" style="padding:0;">
                                <div class="left"><img :src="item.head_img" alt=""></div>
                                <div class="left" style="max-width: 720px;">
                                    <div style="font-weight: bold;font-size: 15px;">{{item.user_nickname}}</div>
                                    <div style="margin:8px 0;    overflow: hidden;text-overflow: ellipsis;display: -webkit-box;white-space: normal;-webkit-line-clamp: 1;-webkit-box-orient: vertical;">{{item.content}}</div>
                                    <div class="create_time">{{item.create_time}} 
                                        <span style="margin-left:16px;cursor: pointer;" v-if="item.show" @click="replyClick(item,index)">{{ $t('回复') }}</span> 
                                    <span @click="replyClick(item,index)" class="replyClickHide" v-else style="cursor: pointer;">{{ $t('收起回复') }}</span></div>
                                </div>

                            </div>
                            <div class="ulLi" v-if="item.reply_list && item.reply_list.length>0">
                                <ul class="clearfix" style="padding:0;" v-for="(reply_list,index) in item.reply_list" :key="index">
                                    <li class="left"> 
                                    <img :src="reply_list.head_img" alt="">
                                    </li>
                                    <li class="left" style="width:auto;max-width: 670px;text-align: left;"> 
                                        <p class="clearfix" style="padding:0;"><span  class="left"  style="font-size: 14px;font-family: PingFang SC-Medium, PingFang SC;font-weight: bold;color: #666666;">{{reply_list.user_nickname}}:</span><span class="left" style="font-size: 16px;font-family: PingFang SC-Regular, PingFang SC;font-weight: 400;color: #333333;max-width: 564px; overflow: hidden;text-overflow: ellipsis;display: -webkit-box;white-space: normal;-webkit-line-clamp: 1;-webkit-box-orient: vertical;">{{reply_list.content}}</span></p>
                                        <p style="font-size: 14px;font-family: PingFang SC-Regular, PingFang SC;font-weight: 400;color: #999999;text-align: left;">{{reply_list.create_time}} </p>
                                    </li>
                                </ul>
                            </div>
                            <div class="ulLi" v-if="!item.show">
                                <ul class="clearfix" style="padding:0;">
                                    <li class="left"> 
                                    <img :src="userInfoMobile.head_img" alt="">
                                    </li>
                                    <li class="left" > 
                                        <!-- <el-input placeholder="回复愤怒的小鸟:" v-model="input1" maxlength="100">
                                            <template slot="append"> <img src="@/imgs/smile.png" class="input1Img" alt="" style="width: 24px !important;height: 24px !important" ></template>
                                        </el-input> -->
                                        <TwemojiTextarea @input="twemojiInput" ref="TwemojiTextarea" :type="1" ></TwemojiTextarea>
                                    </li>
                                    <li class="right"> 
                                        <el-button @click="published(item)">{{ $t('发表') }}</el-button>
                                    </li>
                                </ul>
                            </div>
                            <el-divider></el-divider>
                        </div>
                    </div>
                    
                </div>
                <div  class="text item" style="margin-bottom: 69px;height:106px;" v-else >{{ $t('暂无数据') }}</div>
               <div class="commentList" ref="backTop" :style="{position:scrollBottom<=400?'absolute':'fixed'}"  @click="addExpress">
                   <ul class="clearfix" style="padding:0;" >
                        <li class="left"> 
                        <img src="@/imgs/comment_1.png" alt="">
                        </li>
                        <li class="left" style="margin-left:16px;    position: relative;"> 
                            <TwemojiTextarea @input="twemojiInput" ref="TwemojiTextarea" :type="0"></TwemojiTextarea>
                            <!-- <twemoji-textarea 
                                ref="twemoji"
                                placeholder="留下你的精彩评论吧"
                                :initialContent='input2'
                                @contentChanged="contentChanged"
                                :emojiData="emojiDataAll" 
                                :emojiGroups="emojiGroups" 
                                @enterKey="onEnterKey" style="width: 500px;">
                            </twemoji-textarea> -->
                            <!-- <el-input placeholder="留下你的精彩评论吧:" v-model="input2" maxlength="100">
                                <template slot="append"> 
                                    <img src="@/imgs/smile.png" alt="" style="width:24px !important;height:24px !important;position: absolute;top: 15px;right: 5px;">
                                    
                                </template>
                            </el-input> -->
                            
                        </li>
                        <li class="right" style="margin-left: 15px;"> 
                            <el-button @click="publishedClick">{{ $t('发表') }}</el-button>
                        </li>
                    </ul>
               </div>
            </el-card>
        

  </section>
</template>

<script>
import Service from "@/api/request/index.js";
// import {
//     TwemojiTextarea
//   } from '@kevinfaguiar/vue-twemoji-picker';
//   import EmojiAllData from '@kevinfaguiar/vue-twemoji-picker/emoji-data/zh/emoji-all-groups.json';
//   import EmojiGroups from '@kevinfaguiar/vue-twemoji-picker/emoji-data/emoji-groups.json';
import TwemojiTextarea from './twemoji.vue';
export default {
  name: "comment",
  components: {
     TwemojiTextarea
  },
  data() {
    return {
        show:true,
        input2:'',
        input1:'',
        scrollBottom:0,
        // 页码/条数
        queryParams:{
            page:1,
            list_rows:15,
            type: "1",
            id: '',
        },
        commentList:[],//评论列表
        userInfoMobile:{}, //当前登录人信息
        boxShow: false,
    };
  },
  props:['type'],
  computed: {
      emojiDataAll() {
          return EmojiAllData;
      },
      emojiGroups() {
          return EmojiGroups;
      }
    },
  created() {
       console.log("this.$route.query.userId", this.$route.query.userId,'---------')
       this.userInfoMobile = JSON.parse(localStorage.getItem('USER_INFO'));
    this.queryParams.id = this.$route.query.userId;
    // 十类文章评论列表接口
    this.post62bc007adce19();
  },
  methods: {
    addExpress() {
        console.log("触发事件")
        document.body.style.overflow='hidden'
        // this.scrollBottom = 0;
        // document.body.scrollTop  = document.documentElement.scrollHeight
    //    let top = document.querySelector("#app").scrollTop
    //    console.log("object", document.querySelector("#app").scrollTop,document.querySelector(".commentList").offsetTop)
    //    document.querySelector("#app").scrollTop=document.querySelector(".commentList").offsetTop
        // console.log(top,document.querySelector("#app").offsetTop)
        // document.getElementById('popper-container').style.position='fixed !important'
        // console.log( '触发事件',document.getElementById('popper-container'),document.getElementById('app').style.background='rgba(0, 0, 0, 0.7)',document.getElementById('popper-container').style.position='fixed !important');
    },
    //禁止滚动条滚动
    stop(){
        var mo=function(e){e.preventDefault();};
        console.log("mo", mo)
        // document.body.style.overflow='hidden';
        // document.getElementById('app').style.overflow='hidden';
        // document.addEventListener("touchmove",mo,false);
    },
    //   获取评论
    twemojiInput(item,index) {
        if(index==1) {
            this.input1 = item;
        } else if(index == 0) {
            this.input2 = item;
        }
    },
    //   回复
    replyClick(item,index) {
        console.log("item,index", item.show,index)
        item.show = !item.show
    },
    // 计算高度
    handleScroll(event) {
        let scrollHeight = event.target.scrollHeight
        // 变量 windowHeight 是可视区的高度
        let windowHeight = event.target.clientHeight
        // 变量scrollTop为当前页面的滚动条纵坐标位置
        let scrollTop = event.target.scrollTop
        // 滚动条到底部得距离 = 滚动条的总高度 - 可视区的高度 - 当前页面的滚动条纵坐标位置
        var scrollBottom = scrollHeight - windowHeight - scrollTop
        this.scrollBottom = scrollBottom
        // console.log(scrollBottom,'scrollBottom',windowHeight,scrollHeight,scrollTop)
    },
    // 十类文章评论列表接口
    post62bc007adce19() {
        this.queryParams.type = this.type
        Service.post62bc007adce19(this.queryParams).then(res=>{
            console.log("res", res)
            if(res.code==1) {
                for(let item of res.data.data) {
                    this.$set(item,'show',true)
                }
                // 评论列表
                this.commentList = res.data.data;
            }
        })
    }, 
    // 十类文章评论提交接口
    publishedClick(){
        if(!this.input2) return this.$message.warning(this.$t('请输入评论'))
        let data = {
            content: this.input2,
            id: this.queryParams.id,
            pl_id: "0",
            type: this.type,
        }
        Service.post62bc05a7e6bf1(data).then(res=>{
            console.log("res", res)
            this.input2=''; //清空
            // 清空评论组件
            this.$refs.TwemojiTextarea.input2 = null;
            this.$refs.TwemojiTextarea.clear()
            console.log("this.$refs.TwemojiTextarea.input2", this.$refs.TwemojiTextarea.input2)
            this.$forceUpdate(); //强制刷新
            if(res.code==1) {
                this.$message.success(res.msg)
                this.$nextTick(()=>{
                    // 十类文章评论列表接口
                    this.post62bc007adce19();
                    
                })
            } else {
                this.$message.error(res.msg);
            }
        })
    },
    // 十类文章评论提交接口
    published(item) {
        if(!this.input1) return this.$message.warning(this.$t('请输入评论'))
        let data = {
            content: this.input1,
            id: this.queryParams.id,
            pl_id: item.id,
            type: this.type,
        }
        Service.post62bc05a7e6bf1(data).then(res=>{
            console.log("res", res)
            this.input1=''; //清空
            if(res.code==1) {
                this.$message.success(res.msg)
                
                this.$nextTick(()=>{
                    // 十类文章评论列表接口
                    this.post62bc007adce19();
                })
            }else {
                this.$message.error(res.msg);
            }
        })
    }

  },
  mounted() {
      // 滚动条的获取
    　　window.addEventListener('scroll', this.handleScroll, true);
        document.body.scrollTop = document.documentElement.scrollTop = 0;
            const anchorEle = document.querySelector("#app");
            console.log("anchorEle", anchorEle);
            if (!!anchorEle ) {
                console.log("anchorEle", anchorEle);
                anchorEle.scroll({
                    top: anchorEle.offsetTop ,
                    behavior: 'smooth' // 平滑移动
                })
            }
  },
};
</script>

<style scoped lang="scss">
@import "themePath/Monitor/cl-css";
@import "themePath/railscasts";
.new-right{
    margin-top: 0;
}

.cl-card-main-title {
    span {
        line-height: 21px;
        text-align: center;
        display: inline-block;
        width: 40px;
        height: 21px;
        background: #F7C54A;
        border-radius: 2px 2px 2px 2px;
        font-size: 12px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        margin-right: 8px;
        color: #FFFFFF !important;
    }
    span:nth-child(2) {
        width: 40px;
        height: 21px;
        line-height: 21px;
        text-align: center;
        background: transparent;
        display: inline-block;
        border: 1px solid #F7C54A;
        border-radius: 2px 2px 2px 2px;
        font-size: 12px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: #F7C54A !important;
    }
}
.imgList {
    .cl-card-main-info {
        width: 808px;
    //     overflow: hidden; /*文本超出隐藏*/
	// text-overflow: ellipsis; /*文本超出显示省略号*/
	// white-space: nowrap; /*超出的空白区域不换行*/
        height: auto;
        margin: 0 0 8px 0;
        color: #666666;
    }
    li {
        width: 248px;
        img {
            width:100%;
            height: 172px;
        }
    }
}
.cl-card{
    padding: 0;
}
.cl-card .cl-card-image {
    // height: 128px;
}
.jine {
    position: absolute;
    bottom: 0;
    font-size: 22px;
font-family: Circular-Bold, Circular;
font-weight: bold;
color: #FF1717;
}
.cl-card-main-info {
     width: 606px;
    margin: 0;
    height: auto;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
    display: -webkit-box;
}
.bssCenten{
    background: #FFFFFF;
    .bbs_img{
        margin-left: 73px;
    }
    .clearfix {
        margin-top: 10px;
        padding: 20px 24px;
        box-sizing: border-box;
        .left {
            margin-right: 8px;
            img {
                width: 66px;
                height: 66px;
                border-radius: 100%;
            }
        }
    }
    .ulLi {
        li {
            text-align: center;
            img {
                width: 34px !important;
                height: 34px !important;
            }
        }
        li:nth-child(2) {
            width: 589px;
        }
        li:first-child{
            text-align: left;
             margin-left: 73px;
        }
         li:last-child{
            text-align: right;
            // margin-right: 73px;
        }
        /deep/ .el-button  {
            background: #F9F5CB;
            border-radius: 8px 8px 8px 8px;
            border: 1px solid #FEE60F;
            color: #FEC70F;
            width: 76px;
            text-align: center;
            height: 40px;
            line-height: 40px;
        }
        /deep/ .el-input-group--append .el-input__inner, .el-input-group__prepend {
            background: #F6F6F6;
            border-radius: 8px 0 0 8px;
            opacity: 1;
            height: 40px;
        }
        /deep/ .el-input-group__append, .el-input-group__prepend {
            background: #F6F6F6;
            border-radius: 0 8px 8px 0;
            opacity: 1;
            height: 40px;
        }
    }
}

.commentList {
        position: fixed ;
    bottom: 10px;
    background: #FFFFFF;
box-shadow: 0px 0px 6px 1px rgba(0,0,0,0.05);
border-radius: 4px 4px 4px 4px;
opacity: 1;
bottom: 0;
// width: 790px;
padding: 11px 16px;
    /deep/ .el-button  {
            background: #FEE60F;
            border-radius: 8px 8px 8px 8px;
            border: 1px solid #FEE60F;
            color: #333333;
            width: 89px;
            text-align: center;
            height: 54px;
            line-height: 54px;
            // margin-left: 16px;
        }
        /deep/ .el-input-group--append .el-input__inner, .el-input-group__prepend {
            background: #F6F6F6;
            border-radius: 8px 0 0 8px;
            opacity: 1;
            height: 54px;
            width: 552px;
        }
        /deep/ .el-input-group__append, .el-input-group__prepend {
            background: #F6F6F6;
            border-radius: 0 8px 8px 0;
            opacity: 1;
            height: 40px;
        }
}
.create_time {
font-size: 14px;
font-family: PingFang SC-Regular, PingFang SC;
font-weight: 400;
color: #999999;margin:8px 0

}
.replyClickHide {
font-size: 14px;
font-family: PingFang SC-Regular, PingFang SC;
font-weight: 400;
color: #559AFF;margin-left:16px;
}
.input1Img {
    width:24px !important;height:24px !important;    position: absolute;
    top: 8px;
    right: 16px;
}
>>>#emoji-container > #emoji-popup {
    width: auto !important;
}
>>>#emoji-container > #emoji-popup .emoji-popover-inner {
    width: auto !important;
}
>>> #popper-button {
    position: absolute;
    right: 0;
}
>>> #popper-container {
    position: static !important;
}
>>>.commentList #popper-container {
    position: absolute !important;
}
</style>



// WEBPACK FOOTER //
// src/components/details/comment/index.vue